export const BUNDLE_INVENTORY_GET_REQUEST = 'BUNDLE_INVENTORY_GET_REQUEST';
export const BUNDLE_INVENTORY_GET_SUCCESS = 'BUNDLE_INVENTORY_GET_SUCCESS';
export const BUNDLE_INVENTORY_GET_ERROR = 'BUNDLE_INVENTORY_GET_ERROR';
